export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 20
    },
    {
      prop: 'qualification',
      label: '维修厂资质',
      minWidth: 50
    },
    {
      prop: 'name',
      label: '名称',
      minWidth: 100,
    },
    {
      prop: 'phone',
      label: '联系电话',
      minWidth: 50,
    },
    {
      prop: 'address',
      label: '详细地址',
      minWidth: 150,
    },
    {
      prop: 'status',
      label: '状态',
      minWidth: 50,
    },
    {
      prop: 'is_recommend',
      label: '是否推荐',
      minWidth: 30,
    },
    {
      prop: 'type',
      label: '类型',
      minWidth: 30,
    },
    {
      prop: 'createtime',
      label: '创建时间',
      minWidth: 80,
    },
    {
      prop: "handle",
      label: "操作",
      minWidth: 50,
    },
  ]
}


export default {}